import PropTypes from 'prop-types';
import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { getThemeProps } from 'ravenjs/utils/theme';

const DraggableStyled = styled.div`
    ${getThemeProps('DragAndDrop.styles.draggable')};
    ${({ draggableStyle }) => draggableStyle}
    ${({ isDragging }) => (isDragging ? getThemeProps('DragAndDrop.styles.dragging') : '')}
    ${({ draggingStyle, isDragging }) => (isDragging ? draggingStyle : '')}
`;

const DroppableStyled = styled.div`
    ${getThemeProps('DragAndDrop.styles.container')};
    ${({ droppableStyle }) => droppableStyle}
`;

const DragAndDrop = props => {
    const {
        items,
        onChange,
        styles: { draggable: draggableStyle, dragging: draggingStyle, droppable: droppableStyle },
    } = props;

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }

        onChange(reorder(items, result.source.index, result.destination.index));
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {provided => (
                    <DroppableStyled
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        droppableStyle={droppableStyle}
                    >
                        {items.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(provided, snapshot) => (
                                    <DraggableStyled
                                        ref={provided.innerRef}
                                        draggableStyle={draggableStyle}
                                        draggingStyle={draggingStyle}
                                        isDragging={snapshot.isDragging}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        {item.content}
                                    </DraggableStyled>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </DroppableStyled>
                )}
            </Droppable>
        </DragDropContext>
    );
};

DragAndDrop.propTypes = {
    items: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.shape({
        draggable: PropTypes.object,
        dragging: PropTypes.object,
        droppable: PropTypes.object,
    }),
};

DragAndDrop.defaultProps = {
    items: [],
    styles: {
        draggable: {},
        dragging: {},
        droppable: {},
    },
};

export default DragAndDrop;
